import qconsole from 'scripts/lib/qconsole';

// Resolves email attachments to their signed download URLs, for documents that can't carry the
// session themselves (the sandboxed original-HTML viewer). executeAction discards the return value,
// so the caller passes onFetched; it receives { [attachmentId]: url } for every id that resolved.
export default class FetchEmailAttachmentUrls {
  constructor(context) {
    this.context = context;
  }

  run({ attachmentIds, onFetched }) {
    const gateway = this.context.gateways.emailAttachmentUrl;

    return Promise.all(
      (attachmentIds || []).map(attachmentId =>
        gateway
          .fetch({ attachmentId }, { format: 'url' })
          .then(dto => [attachmentId, dto && dto.url])
          .catch(err => {
            qconsole.error(`Unable to resolve email attachment url: ${JSON.stringify(err)}`);
            return [attachmentId, undefined];
          })
      )
    ).then(pairs => {
      const urlsById = {};
      pairs.forEach(([attachmentId, url]) => {
        if (url) urlsById[attachmentId] = url;
      });
      onFetched && onFetched(urlsById);
    });
  }
}
